import React, { Component } from "react";
import { DateBox, ComboBox } from "rc-easyui";
import { Button } from "reactstrap";
import setTitle from "../../helpers/TitleComponent";
import { getAccessToken, getCookie } from "../../helpers/cookieHelper";
import { isEmpty, getFormattedDate, isEmptyString } from "../../helpers";
import { API_URL } from "../../constants";
import "./Report.css";
import { exportToCSV } from "../../helpers";
const axios = require("axios");

export default class ClientPaymentReport extends Component {
  constructor() {
    super();
    this.state = {
      clientInfo: {},
      isLoading: false,
      data: [],
      form: {
        clientid: "",
        fromdate: "",
        todate: "",
      },
      clients: [
        { value: 1, text: "Dhamala Dairy" },
        { value: 2, text: "ABC Dairy" },
        { value: 3, text: "XYZ Dairy" },
      ],
    };
    this.generateReport = this.generateReport.bind(this);
    this.exportToExcel = this.exportToExcel.bind(this);
  }

  async getClientsForComboBox() {
    var token = getCookie("access_token");
    var tokenType = getCookie("token_type");
    let apiUrl = `${API_URL}api/allclientinfo`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };
    if (token != null) {
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          if (response.status === 200 && !isEmpty(response.data)) {
            this.setState({
              clients: response.data.object,
            });
          }
        })
        .catch(function (error) {});
    } else {
      const resp = await getAccessToken();
      if (resp) {
        this.getClientsForComboBox();
      }
    }
  }
  handleChange(name, value) {
    let form = Object.assign({}, this.state.form);

    if (name === "clientid") {
      form[name] = isEmptyString(value) ? "" : value;
      this.setState({ form: form, data: [] });
    } else {
      form[name] = value;
      this.setState({ form: form });
    }

    //console.log(value);
  }

  componentDidMount() {
    setTitle("Client Payment Report");
    this.getClientsForComboBox();
  }

  async generateReport() {
    let token = getCookie("access_token");
    let tokenType = getCookie("token_type");
    let form = Object.assign({}, this.state.form);
    if ((form.fromdate == "") & (form.todate == "")) {
      alert("From and To date is required");
      return;
    }
    form["fromdate"] = getFormattedDate(form["fromdate"]);
    form["todate"] = getFormattedDate(form["todate"]);

    let apiUrl = `${API_URL}api/clientpaymenthistory?clientid=${form.clientid}&fromdate=${form.fromdate}&todate=${form.todate}`;
    let headersConfig = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `${tokenType} ${token}`,
      },
    };

    //No Form Validation Error
    if (token != null) {
      //Access Token Available
      this.setState({
        isLoading: true,
      });
      axios
        .get(apiUrl, headersConfig)
        .then((response) => {
          //console.log("response", response);
          if (response.status === 200) {
            this.setState({
              isLoading: false,
            });
            if (response.data.status) {
              var data = [];
              var clientInfo = {};
              if (form["clientid"] === "") {
                data = response.data.object;
                if (data.length === 0) {
                  alert("No Data Found");
                  return;
                }
                clientInfo = {};
                this.setState({
                  clientInfo: clientInfo,
                  data: data,
                });
              } else {
                data = response.data.object.datarecords;
                clientInfo = response.data.object.topheader;
                if (data.length === 0) {
                  alert("No Data Found");
                  return;
                }
                this.setState({
                  clientInfo: clientInfo,
                  data: data,
                });
              }
            } else {
              this.setState({
                isLoading: false,
              });
              alert("No data found");
            }
            // this.props.formClear();
          } else {
            alert("Internal Server Error");
          }
        })
        .catch((error) => {
          this.setState({
            isLoading: false,
          });
          alert("Internal Server Error");
        });
    } else {
      //Access Token Expired.
      //Generate new Access Token using Refresh Token.
      const resp = await getAccessToken();
      if (resp) {
        this.generateReport();
      }
    }
  }
  print() {
    window.print();
    window.location.reload();
  }
  exportToExcel() {
    exportToCSV(this.state.data, "Client Payment Report" + Date());
  }
  render() {
    const clientInfo = this.state.clientInfo;
    const loading = this.state.isLoading;
    return (
      <div className='container-fluid'>
        <div className='noprint'>
          <div
            className='loadingmodel'
            style={{ display: loading ? "block" : "none" }}
          ></div>
          <p className='text-danger'>Fields with * are mandatory</p>
          <div className='row'>
            <div className='col-12 col-md-4'>
              <b>Client</b>
              <ComboBox
                style={{ width: "100%" }}
                data={this.state.clients}
                onChange={(e) => this.handleChange("clientid", e)}
                // value={form.clientName}
                valueField='clientid'
                textField='organizationname'
              ></ComboBox>
            </div>
            <div className='col-12 col-md-2'>
              <b>
                From <span className='text-danger'>*</span>
              </b>
              <br />

              <DateBox
                inputId='fromdate'
                format='yyyy-MM-dd'
                style={{ width: "100%" }}
                // value={form.start_date}
                onChange={(e) => this.handleChange("fromdate", e)}
                panelStyle={{ width: 250, height: 300, margin: "auto" }}
              ></DateBox>
            </div>
            <div className='col-12 col-md-2'>
              <b>
                To <span className='text-danger'>*</span>
              </b>

              <br />
              <DateBox
                inputId='todate'
                format='yyyy-MM-dd'
                style={{ width: "100%" }}
                // value={form.start_date}
                onChange={(e) => this.handleChange("todate", e)}
                panelStyle={{ width: 250, height: 300, margin: "auto" }}
              ></DateBox>
            </div>
            <div className='col-12 col-md-3 mt-3'>
              <Button
                className='mx-1'
                onClick={this.generateReport}
                color='primary'
              >
                Generate
              </Button>
              <Button
                className='mx-1'
                onClick={this.exportToExcel}
                color='success'
              >
                Export
              </Button>
              <Button className='mx-1' onClick={this.print} color='info'>
                Print
              </Button>
            </div>
          </div>
        </div>
        <br />
        {this.state.data.length > 0 &&
        !isEmptyString(this.state.form.clientid) ? (
          <div className='row mx-2'>
            <div
              className='col-12 mb-2'
              style={{ margin: "0px", width: "100%" }}
            >
              <h5
                className='text-center'
                style={{ fontWeight: 900, fontSize: "22pt" }}
              >
                Infox IT Pvt. Ltd
              </h5>
              <h6
                className='text-center'
                style={{ fontWeight: 900, fontSize: "18pt" }}
              >
                Butwal-8, Sukkhanagar, Rupandehi,
              </h6>

              <h4
                className='text-center'
                style={{ fontWeight: 900, fontSize: "19pt" }}
              >
                Client Payment Report
              </h4>
              <br />
              <p style={{ marginBottom: 10 }}>
                <span
                  className=''
                  style={{ fontWeight: 900, fontSize: "14pt" }}
                >
                  Client Name:
                  {isEmpty(clientInfo) ? "-" : clientInfo.clientname}
                </span>
                <span
                  className='float-right'
                  style={{ fontWeight: 900, fontSize: "14pt" }}
                >
                  Email: {isEmpty(clientInfo) ? "" : clientInfo.email}
                </span>
              </p>

              <p style={{ marginBottom: 10 }}>
                <span
                  className=''
                  style={{ fontWeight: 900, fontSize: "14pt" }}
                >
                  Address:
                  {isEmpty(clientInfo) ? "-" : clientInfo.address}
                </span>
                <span
                  className='float-right'
                  style={{ fontWeight: 900, fontSize: "14pt" }}
                >
                  Contact:
                  {isEmpty(clientInfo) ? "" : clientInfo.phoneno}
                </span>
              </p>
            </div>

            <table className='table table-bordered report-table'>
              <tr>
                <th width='5%'>S.N.</th>
                <th width='15%'>Date</th>
                <th width='20%'>Amount</th>
                <th width='15%'>Type</th>
                <th>Remarks</th>
              </tr>

              {this.state.data.map((row, i) => (
                <tr>
                  <td>{i + 1}</td>
                  <td>{getFormattedDate(row.entrydate)}</td>
                  <td>Rs. {row.amount.toFixed(2)}</td>
                  <td>{row.transactiontype}</td>
                  <td>{row.remarks}</td>
                </tr>
              ))}
            </table>
          </div>
        ) : (
          ""
        )}

        {this.state.data.length > 0 &&
        isEmptyString(this.state.form.clientid) ? (
          <div className='row mx-2'>
            <div
              className='col-12 mb-2'
              style={{ margin: "0px", width: "100%" }}
            >
              <h5
                className='text-center'
                style={{ fontWeight: 900, fontSize: "22pt" }}
              >
                Infox IT Pvt. Ltd
              </h5>
              <h6
                className='text-center'
                style={{ fontWeight: 900, fontSize: "18pt" }}
              >
                Butwal-8, Sukkhanagar, Rupandehi,
              </h6>

              <h4
                className='text-center'
                style={{ fontWeight: 900, fontSize: "19pt" }}
              >
                Client Payment Report
              </h4>
              <br />
            </div>

            <table className='table table-bordered report-table'>
              <tr>
                <th width='5%'>S.N.</th>
                <th width='18%'>Client Name</th>
                <th width='27%'>Client Address</th>
                <th width='10%'>Date</th>
                <th width='10%'>Amount</th>
                <th width='10%'>Type</th>
                <th>Remarks</th>
              </tr>

              {this.state.data.map((row, i) => (
                <tr>
                  <td>{i + 1}</td>
                  <td>{row.clientname}</td>
                  <td>{row.address}</td>
                  <td>{getFormattedDate(row.entrydate)}</td>
                  <td>Rs. {row.amount.toFixed(2)}</td>
                  <td>{row.transactiontype}</td>
                  <td>{row.remarks}</td>
                </tr>
              ))}
            </table>
          </div>
        ) : (
          ""
        )}
      </div>
    );
  }
}
